import { AxiosInstance } from 'axios'
import MockAdapter from 'axios-mock-adapter'

import { brokerGuidRes } from '@/mock/brokerGuidRes'
import {
  currentInsurers,
  elIndemnityLevels,
  insuranceCovers,
  lookUpResults,
  optionsActivites,
  plIndemnityLevels,
  retviecedPostCode,
} from '@/mock/data'

export const mockIt = (axiosInstance: AxiosInstance) => {
  const useMockResponse = import.meta.env.DEV || true

  if (!useMockResponse) {
    return
  }

  const mock = new MockAdapter(axiosInstance)

  mock.onGet('/email').reply(200, {
    email: { email: 'test@test.com' },
  })

  mock.onGet('/options-activities').reply(200, {
    activites: optionsActivites,
  })

  mock.onGet('/current-insurers').reply(200, {
    currentInsurers: currentInsurers,
  })

  mock.onGet('/insurance-covers').reply(200, {
    insuranceCovers: insuranceCovers,
  })

  mock.onGet('/indemnity-levels').reply(200, {
    plIndemnityLevels: plIndemnityLevels,
    elIndemnityLevels: elIndemnityLevels,
  })

  mock.onGet('/postcodes/lookup').reply(200, {
    result: lookUpResults,
  })

  mock.onGet('/postcodes/retrieve').reply(200, {
    retviecedPostCode,
  })

  mock.onGet('/broker/commercial-combined').reply(200, {
    ...brokerGuidRes,
  })
  mock.onGet('/referral').reply(200, {
    quoteRef: 'mock-referral',
  })
}
